import React from "react";
import { View, Text } from "react-native";
import Icon from "react-native-vector-icons/Feather";

import { Camera, FilePicker } from "utils";
import { styles } from "./styles";

export const CameraMenu = props => {
  const { photo, video, onCapture, style } = props;
  return (
    <View style={[styles.popup, style]}>
      {(photo || video) && (
        <Camera photo={photo} video={video} onCapture={onCapture}>
          <MenuOption icon="camera" label="Camera" />
        </Camera>
      )}
      <FilePicker photo={photo} video={video} onCapture={onCapture}>
        <MenuOption icon="image" label="Gallery" />
      </FilePicker>
    </View>
  );
};

const MenuOption = props => {
  const { icon, label } = props;
  return (
    <View style={[styles.mediaOption]}>
      <Icon name={icon} size={15} color="#005AAB" />
      <Text style={styles.mediaOptionText}>{label}</Text>
    </View>
  );
};
